import { HeaderMenuItem } from './header.types';

export  const headerLinks: HeaderMenuItem[] = [
  {
    text: 'Our Programs',
    path: '#our-programs',
    isHash: true,
  },
  {
    text: 'Dealer Requirements',
    path: '#dealer-requirements',
    isHash: true,
  },
  {
    text: 'Integrator Requirements',
    path: '#integrator-requirements',
    isHash: true,
  },
  {
    text: 'Join Now',
    path: '#inquiry-form',
    isButton: true,
  },
];
